import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import ModalController from 'webmodals/modal.controller'
import utils from 'emun.on-demand/lib/util'
import templateUrl from 'emun.on-demand/confirmations/out-of-bounds-confirmation.htm'

class OutOfBoundsConfirmationController extends ModalController {
    constructor($uibModalInstance, outOfBoundsObjects, options) {
        super($uibModalInstance)
        console.warn('OutOfBoundsConfirmationController', outOfBoundsObjects);
        const $ctrl = this;
        Object.assign($ctrl, options);
        $ctrl.outOfBoundsObjects = outOfBoundsObjects;
        $ctrl.dismiss = $ctrl.cancel = $uibModalInstance.dismiss;
        $ctrl.close = $ctrl.ok = $uibModalInstance.close;
    }
}

const outOfBoundsConfirmation = {
    open(options) {
        const $q = resolve('$q');
        console.warn('outOfBoundsConfirmation', options);
        let outOfBoundsObjects = options.design.objects
            .map(o => Object.assign({splat: utils.splatName(o.layerId || '')}, o))
            .filter(o => o.isOutOfBounds);
        console.warn('options.design', options.design);
        console.warn('outOfBoundsObjects', outOfBoundsObjects);
        if (!outOfBoundsObjects.length) return $q.when(true);
        outOfBoundsObjects.forEach(o => options.design.validationMessages.push('Out of Bounds: ' + (o.layerId || o.name || o.type)));
        let mi = modals.open(Object.assign({
            templateUrl,
            resolve: {
                options: () => options,
                outOfBoundsObjects: () => outOfBoundsObjects
            },
            controller: OutOfBoundsConfirmationController,
            controllerAs: '$ctrl'
        }, options.modal));
        console.warn('outOfBoundsConfirmation.mi', mi);
        return mi.result;
    }
}

export default outOfBoundsConfirmation;